import Text from '~/common/components/Texts/Text';
import Grid from '~/common/mui/Grids/Grid';
import GridItem from '~/common/mui/Grids/GridItem';
import { pixelsToRem } from '~/theme/typography';

type BreakdownColumnBoxProps = {
  title: string;
} & React.ComponentProps<typeof Grid>;

export default function BreakdownColumnBox({
  title,
  children,
  ...props
}: Readonly<BreakdownColumnBoxProps>) {
  return (
    <Grid {...props} gridTemplateColumns="fit-content(30%) 1fr" as="dl">
      <GridItem as="dt">
        <Text
          fontSize={pixelsToRem(14)}
          fontWeight="bold"
          display="inline"
          pr={3}
        >
          {title}
        </Text>
      </GridItem>
      <GridItem as="dd">{children}</GridItem>
    </Grid>
  );
}
